module.exports = __webpack_public_path__ + "img/robo.081e5a2d.png";